import { createStore as create } from 'zustand/vanilla';

document.addEventListener('DOMContentLoaded', () => {
    const forwardedUrlParams = ['sort', 'p'];

    const containerElement = document.querySelector('.event-list__container');

    if (!containerElement) {
        return;
    }
    const useGeoStore = create((set) => ({
        latitude: null,
        longitude: null,
        active: false, // true om geolocation är aktiverat
        setGeolocation: (lat, lng) => {
            const lngInput = document.querySelector('input[name="longitude"]');
            const latInput = document.querySelector('input[name="latitude"]');

            lngInput.value = lng;
            latInput.value = lat;
            updateSearchURL();
            set({
                latitude: lat,
                longitude: lng,
                active: true,
            });
        },
        clearGeolocation: () => {
            const lngInput = document.querySelector('input[name="longitude"]');
            const latInput = document.querySelector('input[name="latitude"]');

            lngInput.value = '';
            latInput.value = '';
            setDropdownFromInputValues('location', '');
            set({
                latitude: null,
                longitude: null,
                active: false,
            });
        },
    }));
    const querySelector = (src, str) => src.querySelector(`.${str}`);
    const state = {
        params: new URLSearchParams(window.location.search),
        loading: false,
        abortController: new AbortController(),
        loadingElement: () => querySelector(document, 'event-list__loader'),
        loadingClassBase: 'event-list__loader',
        containerElement: containerElement,
        containerClass: 'event-list__container',
        initialElement: document.querySelector('.event-list__initial-content'),
        initialElementClass: 'event-list__initial-content',
        toggleElementsBasedOnParams: function () {
            const hasParams = Array.from(this.params.keys()).length > 0;

            if (hasParams) {
                this.initialElement.classList.add(
                    `${this.initialElementClass}--hidden`
                );
                this.containerElement.classList.remove(
                    `${this.containerClass}--hidden`
                );
                if (!this.loading) {
                }
            } else {
                this.containerElement.classList.add(
                    `${this.containerClass}--hidden`
                );
                this.initialElement.classList.remove(
                    `${this.initialElementClass}--hidden`
                );
                this.loadingElement(`${this.loadingClassBase}--hidden`);
            }
        },
        updateParams: function () {
            this.params = new URLSearchParams(window.location.search);
            this.toggleElementsBasedOnParams();
        },
        setLoading(loading) {
            this.loading = loading;
            if (this.abortController) this.abortController.abort();

            this.abortController = new AbortController();
            this.updateLoadingElement();
        },
        filterCount: 0,
        getFilterCount() {
            return state.filterCount;
        },
        setFilterCount(count) {
            this.params.delete('p');
            this.filterCount = count;
            this.updateFilterCountElement();
            this.updateClearAllDisplay();
        },
        updateFilterCountElement() {
            const filterCountContainer = document.querySelector('.filter-info');
            if (filterCountContainer) {
                this.getFilterCount() === 0
                    ? filterCountContainer.classList.add('filter-info--hidden')
                    : filterCountContainer.classList.remove(
                          'filter-info--hidden'
                      );
            }
            const filterCountElement = document.querySelector('.filter-count');
            if (filterCountElement) {
                filterCountElement.textContent = this.getFilterCount();
            }
        },
        updateClearAllDisplay() {
            const clearAllButton = document.querySelector(
                '.EventFilter__dropdown_hidden-clear'
            );
            if (this.getFilterCount() === 0) {
                clearAllButton.classList.remove(
                    'EventFilter__dropdown_hidden-clear--expanded'
                );
            } else {
                clearAllButton.classList.add(
                    'EventFilter__dropdown_hidden-clear--expanded'
                );
            }
        },
        getSignal() {
            return this.abortController?.signal;
        },
        expandedFilters: false,
        loadingHtml: `<div class="loading-dots"><div></div><div></div><div></div><div/>`,
        updateLoadingElement() {
            const loader = this.loadingElement();
            const sortContainer = document.querySelector(
                '.event-list__sortresults'
            );
            const eventListContainer = document.querySelector('#event-list');
            if (this.loading) {
                loader.innerHTML = this.loadingHtml;
                loader.classList.remove(`${this.loadingClassBase}--hidden`);
                sortContainer.classList.add('event-list__row--hidden');
                eventListContainer.innerHTML = '';
            } else {
                loader.classList.add(`${this.loadingClassBase}--hidden`);
                sortContainer.classList.remove('ehvent-list__row--hidden');
            }
        },
        hasSearchTextInput: false,
        updateHasSearchTextInput: (value) => {
            state.hasSearchTextInput = value;
            state.toggleElementsBasedOnParams();
            state.updateClearAllDisplay();
        },
    };
    const handleExpandToggle = () => {
        const hiddenArea = document.querySelector(
            '.EventFilter__dropdown_hidden'
        );
        hiddenArea.classList.toggle('EventFilter__dropdown_hidden--expanded');
        state.expandedFilters = !state.expandedFilters;
        const expandButton = document.querySelector(
            '#EventFilter__button--expand'
        );
        expandButton.innerText = state.expandedFilters
            ? 'Dölj filter'
            : 'Fler filter';
    };

    const updateListItemsTabindex = (dropdown) => {
        const container = dropdown.querySelector(
            '.EventFilter__dropdown__container-list'
        );
        if (container) {
            if (dropdown.classList.contains('active')) {
                container.classList.add(
                    'EventFilter__dropdown__container--open'
                );
                for (const item of container.querySelectorAll(
                    '.EventFilter__dropdown_item'
                )) {
                    item.setAttribute('tabindex', '1');
                }
            } else {
                container.classList.remove(
                    'EventFilter__dropdown__container--open'
                );
                for (const item of container.querySelectorAll('li')) {
                    item.setAttribute('tabindex', '0');
                }
            }
        }
    };
    const handleDropdownToggle = () => {
        for (const button of document.querySelectorAll(
            '.EventFilter__dropdown-toggle'
        )) {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const dropdown = button.closest('.EventFilter__dropdown');
                const isActive = dropdown.classList.contains('active');

                for (const d of document.querySelectorAll(
                    '.EventFilter__dropdown'
                )) {
                    d.classList.remove('active');
                    updateListItemsTabindex(d);
                }

                if (!isActive) {
                    dropdown.classList.add('active');
                } else {
                    dropdown.classList.remove('active');
                }
                updateListItemsTabindex(dropdown);

                const clearAll = dropdown.querySelector(
                    '.EventFilter__clear_all'
                );
                if (clearAll) {
                    clearAll.addEventListener('click', (e) => {
                        e.stopPropagation();
                        e.preventDefault();

                        for (const item of dropdown.querySelectorAll(
                            '.EventFilter__dropdown__list li'
                        )) {
                            if (item.classList.contains('selected')) {
                                state.setFilterCount(--state.filterCount);
                            }
                            item.classList.remove('selected');

                            const checkbox = item.querySelector('.checkbox');
                            if (checkbox) {
                                checkbox.setAttribute('aria-checked', 'false');
                            }
                        }

                        const hiddenInput = dropdown.querySelector(
                            "input[type='hidden']"
                        );
                        if (hiddenInput) {
                            hiddenInput.value = '';
                            clearAll.setAttribute('disabled', 'disabled');
                        }

                        // Få ID:t från dropdown för att hitta rätt label
                        const dropdownId = dropdown.id.replace('dropdown-', '');
                        const toggleLabelId = `EventFilter__dropdown-toggle-label-${dropdownId}`;
                        const toggleLabel = dropdown.querySelector(
                            `#${toggleLabelId}`
                        );

                        const dropdownToggle = dropdown.querySelector(
                            '.EventFilter__dropdown-toggle'
                        );
                        const initialPlaceHolder =
                            dropdownToggle.getAttribute('data-initial-value');
                        if (toggleLabel) {
                            toggleLabel.textContent = initialPlaceHolder;
                        }
                        state.updateFilterCountElement();

                        updateSearchURL();

                        state.toggleElementsBasedOnParams();
                    });
                }
            });
        }

        const locationDropdownClear = document.querySelector(
            '.EventFilter__dropdown_locations .EventFilter__clear_all'
        );
        if (locationDropdownClear) {
            locationDropdownClear.addEventListener('click', (e) => {
                useGeoStore.getState().clearGeolocation();
            });
        }

        document.addEventListener('focusout', (e) => {
            for (const dropdown of document.querySelectorAll(
                '.EventFilter__dropdown'
            )) {
                if (!dropdown.contains(e.target)) {
                    dropdown.classList.remove('active');
                    updateListItemsTabindex(dropdown);
                }
            }
        });

        document.addEventListener('keyup', (e) => {
            for (const dropdown of document.querySelectorAll(
                '.EventFilter__dropdown'
            )) {
                if (e.key === 'Escape') {
                    dropdown.classList.remove('active');
                    updateListItemsTabindex(dropdown);
                }
            }
        });
        document.addEventListener('click', (e) => {
            for (const dropdown of document.querySelectorAll(
                '.EventFilter__dropdown'
            )) {
                if (!dropdown.contains(e.target)) {
                    dropdown.classList.remove('active');
                    updateListItemsTabindex(dropdown);
                }
            }
        });
    };
    const searchInput = document.querySelector('#search-query');
    if (searchInput) {
        // Hämta "q"-parametern från URL:en
        const qParam = state.params.get('q');
        if (qParam) {
            searchInput.value = qParam;
            state.updateHasSearchTextInput(true);
        }

        searchInput.addEventListener('input', (e) => {
            e.preventDefault();
            e.stopPropagation();
        });

        searchInput.addEventListener('keypress', async (e) => {
            if (e.key === 'Enter') {
                const updatedURL = updateSearchURL();
                state.updateHasSearchTextInput(
                    e.currentTarget.value.length > 0
                );
                await getSearchContent(updatedURL);
            }
        });
    }
    const searchButtons = document.querySelectorAll(
        '.EventFilter__item_search'
    );
    for (const button of searchButtons) {
        button.addEventListener('click', async (e) => {
            for (const d of document.querySelectorAll(
                '.EventFilter__dropdown'
            )) {
                d.classList.remove('active');
                updateListItemsTabindex(d);
            }

            const updatedURL = updateSearchURL();
            await getSearchContent(updatedURL);
        });
    }

    const expandButton = document.querySelector('#EventFilter__button--expand');
    if (expandButton) {
        expandButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            handleExpandToggle();
        });
    }
    const handleDropdownItemEvent = async (e) => {
        if (e.type === 'keypress' && ![' ', 'Enter'].includes(e.key)) {
            return;
        }

        e.preventDefault();
        const listItem = e.currentTarget;
        const dropdown = listItem.closest('.EventFilter__dropdown');
        if (!dropdown) return;

        const hiddenInput = dropdown.querySelector("input[type='hidden']");
        // Få ID:t från dropdown för att hitta rätt label
        const dropdownId = dropdown.id.replace('dropdown-', '');
        const toggleLabelId = `EventFilter__dropdown-toggle-label-${dropdownId}`;
        const toggle = dropdown.querySelector(`#${toggleLabelId}`);

        listItem.classList.toggle('selected');

        const checkbox = listItem.querySelector('.checkbox');
        if (checkbox) {
            const isChecked = checkbox.getAttribute('aria-checked');
            checkbox.setAttribute(
                'aria-checked',
                isChecked === 'true' ? 'false' : 'true'
            );
        }

        const selectedItems = Array.from(
            dropdown.querySelectorAll(
                '.EventFilter__dropdown__list li.selected'
            )
        );
        const selectedValues = selectedItems.map((li) =>
            li.getAttribute('data-value')
        );
        const selectedText = selectedItems.map((li) =>
            li.getAttribute('visual-value')
        );

        hiddenInput.value = selectedValues.join(',');

        const button = dropdown.querySelector('.EventFilter__dropdown-toggle');
        const initialPlaceholder = button.getAttribute('data-initial-value');
        const clearButton = dropdown.querySelector('.EventFilter__clear_all');

        if (clearButton && selectedText.length > 0) {
            clearButton.removeAttribute('disabled');
        } else if (clearButton && selectedText.length === 0) {
            clearButton.setAttribute('disabled', 'disabled');
        }

        const newTextValue =
            selectedText.length > 1
                ? `${selectedText[0]} <span class="EventFilter__filter__index">(+${selectedText.length - 1})</span>`
                : selectedText.length > 0
                  ? selectedText.join(', ')
                  : initialPlaceholder;
        toggle.innerHTML = newTextValue;

        const totalSelectedFilters = document.querySelectorAll(
            '.EventFilter__dropdown__list li.selected'
        ).length;
        state.setFilterCount(totalSelectedFilters);

        const updatedURL = updateSearchURL();
        await getSearchContent(updatedURL);
    };

    const handleDropdownSelection = () => {
        const eventTypes = ['click', 'keypress'];
        for (const item of document.querySelectorAll(
            '.EventFilter__dropdown__list li'
        )) {
            for (const eventType of eventTypes) {
                item.addEventListener(eventType, handleDropdownItemEvent);
            }
        }
    };

    const clearAllSelections = () => {
        const clearAllButton = document.querySelector('#EventFilter__all');
        if (clearAllButton) {
            clearAllButton.addEventListener('click', async (e) => {
                e.stopPropagation();
                e.preventDefault();

                const searchInput = document.querySelector('#search-query');

                searchInput.value = '';
                state.updateHasSearchTextInput(false);
                for (const dropdown of document.querySelectorAll(
                    '.EventFilter__dropdown'
                )) {
                    for (const item of dropdown.querySelectorAll(
                        '.EventFilter__dropdown__list li'
                    )) {
                        item.classList.remove('selected');
                        const checkbox = item.querySelector('.checkbox');
                        if (checkbox) {
                            checkbox.setAttribute('aria-checked', 'false');
                        }
                    }

                    const hiddenInput = dropdown.querySelector(
                        "input[type='hidden']"
                    );
                    if (hiddenInput) {
                        hiddenInput.value = '';
                    }

                    // Få ID:t från dropdown för att hitta rätt label
                    const dropdownId = dropdown.id.replace('dropdown-', '');
                    const toggleLabelId = `EventFilter__dropdown-toggle-label-${dropdownId}`;
                    const toggle = dropdown.querySelector(`#${toggleLabelId}`);

                    const button = dropdown.querySelector(
                        '.EventFilter__dropdown-toggle'
                    );
                    const initialPlaceHolder =
                        button.getAttribute('data-initial-value');

                    if (toggle) {
                        toggle.textContent = initialPlaceHolder
                            ? initialPlaceHolder
                            : 'Välj alternativ';
                    }

                    state.toggleElementsBasedOnParams();
                }

                state.setFilterCount(0);
                updateSearchURL();
                handleExpandToggle();
            });
        }
        updateSearchURL();
    };

    const updateSearchURL = (additionalParams = '') => {
        const params = new URLSearchParams();

        for (const input of document.querySelectorAll("input[type='hidden']")) {
            const name = input.name;
            const values = input.value;

            if (values?.trim()) {
                for (const value of values.split(',')) {
                    if (value.trim()) {
                        params.append(name, value.trim());
                    }
                }
            }
        }
        for (const input of document.querySelectorAll("input[type='search']")) {
            const name = input.name;
            const value = input.value;

            if (value?.trim()) {
                params.append(name, value.trim());
            }
        }
        const baseUrl = window.location.origin + window.location.pathname;
        const nullParamValues = [null, undefined, '', 'null', 'undefined'];

        for (const parameter of forwardedUrlParams) {
            const hasParameter = params.has(parameter);
            const paramValue = state.params.get(parameter);
            const hasValue =
                state.params.has(parameter) &&
                state.params.get(parameter) !== null &&
                !nullParamValues.includes(paramValue);

            if (!hasParameter && hasValue) {
                params.set(parameter, state.params.get(parameter));
            }
        }

        let href = `${baseUrl}?${params.toString()}`;
        href += additionalParams ? `&${additionalParams}` : '';
        window.history.replaceState({}, '', href);
        state.updateParams();
        return href;
    };
    async function getSearchContent(href) {
        state.setLoading(true);
        const beforeSearchContent = state.initlialElement;
        const url = new URL(href);
        const endsWithSlash = url.pathname.endsWith('/');
        url.pathname = url.pathname + (endsWithSlash ? '' : '/') + 'search';

        try {
            const request = await fetch(url, { signal: state.getSignal() });
            const responseJson = await request.json();
            const responseHtml = responseJson.html;

            const asElement = document.createElement('div');
            asElement.innerHTML = responseHtml;

            const container = document.getElementById('event-list-container');
            container.replaceWith(asElement.firstElementChild);
            window.lazyLoader.update();
            if (responseJson.cities) {
                const cities = responseJson.cities.join(',');
                const currentCitiesArray = document
                    .querySelector(`input[type='hidden'][name='location']`)
                    .value.split(',');
                const distinctCities = [
                    ...new Set([...currentCitiesArray, ...cities.split(',')]),
                ].join(',');
                document.querySelector(
                    `input[type='hidden'][name='location']`
                ).value = distinctCities;
                setDropdownFromInputValues('location', distinctCities);
            }
            updateSortLinks();
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.error('Fel vid hämtning av innehåll:', err);
            }
        } finally {
            window.lazyLoader.update();
            state.setLoading(false);
        }
    }

    function updateSortLinks() {
        const sortLinks = document.querySelectorAll('.event-list__sort-link');
        for (const link of sortLinks) {
            link.addEventListener('click', async (e) => {
                e.stopPropagation();
                e.preventDefault();
                const sort = link.getAttribute('data-sort');
                updateSearchURL(`sort=${sort}`);
                await getSearchContent(link.href);
            });
        }
    }

    function getCurrentPositionPromise(options = {}) {
        return new Promise((resolve, reject) => {
            // Standardinställningar med mer konservativa värden
            const defaultOptions = {
                enableHighAccuracy: false, // Sätt till false för att minska risken för timeout
                timeout: 10000, // Kortare timeout för att undvika avstängda kanaler
                maximumAge: 30000, // Tillåt äldre cachade positioner
            };

            const mergedOptions = { ...defaultOptions, ...options };

            // Försök hämta position flera gånger vid fel
            let attempts = 0;
            const maxAttempts = 2;
            let watchId = null;

            function tryGetPosition() {
                attempts++;

                // Extra hantering för Chrome som kan ge 'Position update is unavailable' fel
                function successCallback(position) {
                    if (!position || !position.coords) {
                        if (attempts <= maxAttempts) {
                            setTimeout(tryGetPosition, 1500); // Ökad fördröjning
                        } else {
                            useGoogleMapsGeolocation();
                        }
                        return;
                    }

                    // Rensa watchId om aktiv
                    if (watchId !== null) {
                        navigator.geolocation.clearWatch(watchId);
                    }

                    resolve(position);
                }

                function errorCallback(error) {
                    // Försök igen om vi inte har nått maxgränsen för försök
                    if (
                        attempts <= maxAttempts &&
                        (error.code === error.POSITION_UNAVAILABLE ||
                            error.code === error.TIMEOUT ||
                            error.message === 'Position update is unavailable')
                    ) {
                        setTimeout(tryGetPosition, 1500); // Ökad fördröjning
                    } else {
                        useGoogleMapsGeolocation();
                    }
                }

                // Fallback till att använda IP-baserad geolokalisering via en öppen API
                function useGoogleMapsGeolocation() {
                    // Använd ipapi.co istället för Google API som kräver en nyckel med specifika behörigheter
                    fetch('https://ipapi.co/json/')
                        .then((response) => {
                            if (!response.ok) {
                                throw new Error(
                                    `HTTP error! Status: ${response.status}`
                                );
                            }
                            return response.json();
                        })
                        .then((data) => {
                            if (data?.latitude && data?.longitude) {
                                // Skapa ett position-liknande objekt
                                const position = {
                                    coords: {
                                        latitude: data.latitude,
                                        longitude: data.longitude,
                                        accuracy: 1000,
                                    },
                                    timestamp: new Date().getTime(),
                                };
                                resolve(position);
                            } else {
                                reject(
                                    new Error(
                                        'Kunde inte fastställa position via IP-geolokalisering.'
                                    )
                                );
                            }
                        })
                        .catch((error) => {
                            console.error('IP-geolokalisering error:', error);
                            reject(
                                new Error(
                                    'Kunde inte fastställa position. Var god försök igen senare.'
                                )
                            );
                        });
                }

                // Använd watchPosition som fallback
                function fallbackToWatchPosition() {
                    try {
                        // Försök med watchPosition som ofta fungerar bättre i Chrome på macOS
                        const watchOptions = {
                            ...mergedOptions,
                            timeout: 20000, // Längre timeout för watch
                        };

                        watchId = navigator.geolocation.watchPosition(
                            (position) => {
                                if (position && position.coords) {
                                    navigator.geolocation.clearWatch(watchId);
                                    resolve(position);
                                }
                            },
                            (error) => {
                                navigator.geolocation.clearWatch(watchId);
                                // Efter watchPosition fallback, prova IP-geolokalisering som sista utväg
                                useGoogleMapsGeolocation();
                            },
                            watchOptions
                        );

                        // Sätt en timeout för watchPosition
                        setTimeout(() => {
                            if (watchId !== null) {
                                navigator.geolocation.clearWatch(watchId);
                                // Efter timeout, prova IP-geolokalisering
                                useGoogleMapsGeolocation();
                            }
                        }, 20000);
                    } catch (e) {
                        // Om watchPosition misslyckas, prova IP-geolokalisering
                        useGoogleMapsGeolocation();
                    }
                }

                navigator.geolocation.getCurrentPosition(
                    successCallback,
                    errorCallback,
                    mergedOptions
                );
            }

            tryGetPosition();
        });
    }

    async function handleGeolocationButtonOnClick(button) {
        const state = useGeoStore.getState();
        if (state.active) {
            useGeoStore.getState().clearGeolocation();
            updateSearchURL();
            await getSearchContent(updateSearchURL());
        } else if (navigator.geolocation) {
            try {
                // Visa indikator att positionering pågår
                const geoButton = document.querySelector(
                    '#EventFilter_GeoButton'
                );
                if (geoButton) {
                    const icon = geoButton.querySelector('i');
                    if (icon) {
                        icon.classList.add('fa-spin');
                    }
                    const text = geoButton.querySelector('#geo_text');
                    if (text) {
                        text.innerText = 'Hämtar position...';
                    }
                }

                const position = await getCurrentPositionPromise();

                // Återställ knappens utseende
                if (geoButton) {
                    const icon = geoButton.querySelector('i');
                    if (icon) {
                        icon.classList.remove('fa-spin');
                    }
                }

                state.setGeolocation(
                    position.coords.latitude,
                    position.coords.longitude
                );
                updateSearchURL();
                await getSearchContent(updateSearchURL());
            } catch (error) {
                console.error('Fel vid hämtning av plats: ', error.message);

                // Återställ knappens utseende vid fel
                const geoButton = document.querySelector(
                    '#EventFilter_GeoButton'
                );
                if (geoButton) {
                    const icon = geoButton.querySelector('i');
                    if (icon) {
                        icon.classList.remove('fa-spin');
                    }
                    const text = geoButton.querySelector('#geo_text');
                    if (text) {
                        text.innerText = 'Använd min position';
                    }
                }

                // Mer specifik felhantering baserat på felkod
                let errorMessage = '';
                if (error.code) {
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            errorMessage =
                                'Du måste ge tillåtelse för att använda din plats.';
                            break;
                        case error.POSITION_UNAVAILABLE:
                            errorMessage =
                                'Din position kunde inte fastställas. Försök igen senare.';
                            break;
                        case error.TIMEOUT:
                            errorMessage =
                                'Positioneringen tog för lång tid. Försök igen.';
                            break;
                        default:
                            errorMessage = `Ett fel uppstod vid positionering${error.message ? ': ' + error.message : ''}.`;
                    }
                } else {
                    errorMessage =
                        error.message || 'Ett fel uppstod vid positionering.';
                }

                // Visa ett användarvänligt meddelande
                alert(errorMessage);
            }
        } else {
            alert('Din webbläsare stöder inte platspositionering.');
        }
    }
    useGeoStore.subscribe((state) => {
        const button = document.querySelector('#EventFilter_GeoButton');
        if (!button) return;
        const icon = button.querySelector('i');
        const text = button.querySelector('#geo_text');
        if (state.active) {
            icon.classList.remove('fa-location-crosshairs');
            icon.classList.add('fa-location-crosshairs-slash');
            text.innerText = 'Rensa min position';
        } else {
            icon.classList.remove('fa-location-crosshairs-slash');
            icon.classList.add('fa-location-crosshairs');
            text.innerText = 'Använd min position';
        }
    });

    function initGeoLocation() {
        const button = document.querySelector('#EventFilter_GeoButton');
        if (!button) return;

        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            handleGeolocationButtonOnClick(button);
        });
    }

    const setDropdownFromInputValues = (key, value) => {
        const hiddenInput = document.querySelector(
            `input[type='hidden'][name='${key}']`
        );
        if (hiddenInput) {
            const dropdown = hiddenInput.closest('.EventFilter__dropdown');
            if (dropdown) {
                // Få ID:t från dropdown för att hitta rätt label
                const dropdownId = dropdown.id.replace('dropdown-', '');
                const toggleLabelId = `EventFilter__dropdown-toggle-label-${dropdownId}`;
                const toggle = dropdown.querySelector(`#${toggleLabelId}`);

                const button = dropdown.querySelector(
                    '.EventFilter__dropdown-toggle'
                );
                const initialPlaceHolder =
                    button.getAttribute('data-initial-value');

                if (value === '' || value === null) {
                    for (const item of dropdown.querySelectorAll(
                        '.EventFilter__dropdown__list li'
                    )) {
                        item.classList.remove('selected');
                        const checkbox = item.querySelector('.checkbox');
                        if (checkbox) {
                            checkbox.setAttribute('aria-checked', 'false');
                        }
                    }

                    hiddenInput.value = '';

                    if (toggle) {
                        toggle.textContent = initialPlaceHolder;
                    }

                    state.updateFilterCountElement();
                    updateSearchURL();
                    state.toggleElementsBasedOnParams();
                    return;
                }

                // Avmarkera alla först
                for (const item of dropdown.querySelectorAll(
                    '.EventFilter__dropdown__list li'
                )) {
                    item.classList.remove('selected');
                    const checkbox = item.querySelector('.checkbox');
                    if (checkbox) {
                        checkbox.setAttribute('aria-checked', 'false');
                    }
                }

                const selectedValues = value.split(',').filter((v) => v.trim());
                for (const selectedValue of selectedValues) {
                    if (!selectedValue.trim()) continue;

                    const listItem = dropdown.querySelector(
                        `.EventFilter__dropdown__list li[data-value='${selectedValue}']`
                    );
                    if (listItem) {
                        listItem.classList.add('selected');

                        const checkbox = listItem.querySelector('.checkbox');
                        if (checkbox) {
                            checkbox.setAttribute('aria-checked', 'true');
                        }
                    }
                }

                const selectedText = Array.from(
                    dropdown.querySelectorAll(
                        '.EventFilter__dropdown__list li.selected'
                    )
                ).map((li) => li.getAttribute('visual-value'));
                if (toggle) {
                    if (selectedText.length > 1) {
                        toggle.innerHTML = `${selectedText[0]} <span class="EventFilter__filter__index">(+${selectedText.length - 1})</span>`;
                    } else if (selectedText.length === 1) {
                        toggle.innerHTML = selectedText[0];
                    } else {
                        toggle.textContent = initialPlaceHolder;
                    }
                }
            }
        }
    };

    const initializeFiltersFromURL = () => {
        const params = new URLSearchParams(window.location.search);
        state.params = params;

        const paramMap = new Map();

        params.forEach((value, key) => {
            if (!paramMap.has(key)) {
                paramMap.set(key, []);
            }
            paramMap.get(key).push(value);
        });

        paramMap.forEach((values, key) => {
            setDropdownFromInputValues(key, values.join(','));
        });

        const totalSelectedFilters = document.querySelectorAll(
            '.EventFilter__dropdown__list li.selected'
        ).length;
        state.setFilterCount(totalSelectedFilters);

        const qParam = params.get('q');
        if (qParam) {
            const searchInput = document.querySelector('#search-query');
            if (searchInput) {
                searchInput.value = qParam;
                state.updateHasSearchTextInput(true);
            }
        }

        state.toggleElementsBasedOnParams();

        const lat = params.get('latitude');
        const lng = params.get('longitude');
        if (lat && lng) {
            useGeoStore
                .getState()
                .setGeolocation(Number.parseFloat(lat), Number.parseFloat(lng));
        }
    };

    function handlePaginationClick() {
        const container = document.querySelector('.event-list__container');

        container.addEventListener('click', async (e) => {
            if (e.target.matches('a.paging__link')) {
                e.preventDefault();
                const href = e.target.href;
                const page = new URL(href).searchParams.get('p');
                state.params.set('p', page);
                if (page) {
                    const updatedURL = updateSearchURL();
                    await getSearchContent(updatedURL);
                }
            }
        });
    }

    handleDropdownToggle();
    initializeFiltersFromURL();
    updateSortLinks();
    clearAllSelections();
    initGeoLocation();
    handleDropdownSelection();

    handlePaginationClick();
});
